import { cn } from "@/utils";
import { i18n } from "@lingui/core";
import dayjs from "dayjs";
import { capitalize } from "lodash";

const CalendarDate = ({ date, onClick, isDisabled }) => {
  const dayObject = dayjs(date);

  const dayOfWeek = capitalize(dayObject.locale(i18n.locale).format("dddd"))
    .substring(0, 3)
    .toUpperCase();

  const dayNumber = dayObject.date();

  const isToday = dayObject.isSame(dayjs(), "day");

  return (
    <button
      type="button"
      onClick={() => !isDisabled && onClick(date)}
      className={cn(
        "group flex items-center justify-center text-base md:text-xl",
        {
          "gap-2 font-medium": isToday,
        },
      )}
    >
      <p
        className={cn("dark:text-foreground text-sm text-[#262626]", {
          "text-[#548F68]": isToday,
          "text-[#ccc]": isDisabled,
        })}
      >
        {dayOfWeek}
      </p>

      <p
        className={cn(
          "text-md flex h-9 w-9 shrink-0 items-center justify-center rounded-full font-semibold text-[#548f68] transition-colors md:text-xl",
          {
            "bg-[#548f68] text-white": isToday,
            "text-[#ccc]": isDisabled,
            "group-hover:bg-[#00000013]": !isToday,
          },
        )}
      >
        {dayNumber}
      </p>
    </button>
  );
};

export default CalendarDate;
